module.exports = __webpack_public_path__ + "static/img/8bg_14.0701f20.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/8bg_14.png
// module id = 752
// module chunks = 1